import { useTheme } from "../../../../context/useThemeContext";
import useMainStore from "../../../../stores/mainStore";

function LeftSelectionIndicator(props: { noteID: string }) {
    const { theme } = useTheme();

    const selectedNote = useMainStore((state) => state.data.selectedNoteID);
    const openedNoteIDs = useMainStore((state) => state.data.openedNoteIDs);

    function getOpacity() {
        if (selectedNote === props.noteID) {
            return 1;
        } else if (openedNoteIDs.includes(props.noteID)) {
            return 0.15;
        }
        return 0;
    }

    return (
        <div
            className="leftSelection w-[4px] rounded-lg shrink-0 absolute left-[-8px] top-0 bottom-0"
            style={{
                opacity: getOpacity(),
                backgroundColor: theme.accentColor,
            }}
        />
    );
}

export default LeftSelectionIndicator;
